import Phaser from "phaser";
import { GameScene } from "./scenes/GameScene";
import { Global } from "./utils/Global";
import { StateMachine } from "./utils/StateMachine";
import { GameState } from "./utils/GameState";
import { Jukebox } from "./utils/Jukebox";

export class Client {
  static game: Phaser.Game;
  static state: GameState;
  static stateMachine: StateMachine;
  static jukebox: Jukebox;
  static getActiveScene(): GameScene | undefined {
    return Client.game.scene.getScenes(true)[0] as GameScene;
  }
}

window.onload = function () {
  Client.game = new Phaser.Game(Global.gameConfig);
};

export default Client;
